import type { Race } from '../types/content'

// This is the main file to update whenever Em's schedule or results change.
export const races: Race[] = [
  {
    id: 1,
    date: '10th Oct 2026',
    event: '',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 2,
    date: '24th Oct 2026',
    event: '',
    venue: 'Kingaroy Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 3,
    date: '21st Nov 2026',
    event: 'QLD Title',
    venue: 'Rockhampton Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 4,
    date: '5th Dec 2026',
    event: '',
    venue: 'Kingaroy Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 5,
    date: '8th Jan 2027',
    event: '',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 6,
    date: '23rd - 25th Jan 2027',
    event: 'Kings Royal',
    venue: 'Kingaroy Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 7,
    date: '6th Feb 2027',
    event: '',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 8,
    date: '27th Feb 2027',
    event: '',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 9,
    date: '3rd Apr 2027',
    event: '',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 10,
    date: '1st May 2027',
    event: '',
    venue: 'Gladstone Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 11,
    date: '2nd May 2027',
    event: '',
    venue: 'Kingaroy Speedway',
    status: 'Upcoming',
    result: null,
  },
  {
    id: 12,
    date: '21st - 22nd May 2027',
    event: '50 Lapper',
    venue: 'Toowoomba Speedway',
    status: 'Upcoming',
    result: null,
  },

]

export const seasonStats = [
  { value: '2019', label: 'Racing since' },
  { value: '#7', label: 'Race number' },
  { value: '2023', label: 'Senior debut' },
  { value: '100%', label: 'Commitment' },
]
